<script lang="ts">
	import Button from "../atoms/Button.svelte"

	export let klass = 'rounded-2xl'
	export let full = false
	export let rounded = false
	export let loading = false
	export let click
</script>

<Button
	klass={klass}
	color="bg-red-400  hover:bg-red-500"
	full={full}
	rounded={rounded}
	loading={loading}
	click={click}
><slot></slot>
</Button>